import React from 'react';
import { FaFilePdf, FaGithub, FaLinkedin } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
//import { BsFillPersonLinesFill } from 'react-icons/bs';

const SocialLinks = () => {
    const links = [
    {
        id: 1,
        child: (
            <>
         LinkedIn <FaLinkedin size ={20} />
        </>
        ),
        href: 'https://www.linkedin.com/in/edenkefale/',
        style: 'rounded-tr-md'
    },
    {
        id: 2,
        child: (
            <>
         GitHub <FaGithub size ={20} />
        </>
        ),
        href: 'https://github.com/Eden-Kef',
    },
    {
        id: 3,
        child: (
            <>
         Gmail <HiOutlineMail size ={20} />
        </>
        ),
        href: 'mailto:edenhailemariam01@gmail.com', target:"_blank", rel:"noreferrer",
    },
{
  id: 4,
  child: (
    <>
      Resume <FaFilePdf size={20} />
    </>
  ),
  href: '/UIUXResume.pdf',
  style: 'rounded-br-md',
  // download: true,  <-- remove this
},
    ];

  return (
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
        <ul>
        {links.map(({id, child, href, style}) => (
            <li key={id}
             className={
                "flex justify-between items-center w-36 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-slate-500" + 
                " " +
                style
                }>
                <a 
                href = {href} 
                className= "flex justify-between items-center w-full text-white"
                //download={download}
                target="_blank"
                rel="noreferrer"
                >
               {child}
             </a>
            </li>    
        ))
        } 
        </ul>
    </div>
  )
}

export default SocialLinks;